import {AnyAction} from 'redux';
import {CollectedSelection, CollectedState, KehButton,} from '../../types/redux';
import {
	CONTRACT_WIZARD_NEXT_STEP,
	CONTRACT_WIZARD_PREVIOUS_FORM,
	CONTRACT_WIZARD_RESET_TO_STEP,
	CONTRACT_WIZARD_RESET_TO_STEP_DONE
} from "../actions/contractWizardActions";
import {CONTRACT_NEW, CONTRACT_UPDATE} from "../actions/contract";
import {FETCH_CONTENT_SUCCESS} from "../actions/contentful";

export const SELECTED_LATER = "SELECTED_LATER";
export const SELECTED_NOW = "SELECTED_NOW";

const initialState: CollectedState = {
	status: CollectedSelection.FINISH_NOT_CHOSE,
	selectedButton: KehButton.NOT_SELECTED,
};

export function collectedStateReducer(
	state: CollectedState = initialState,
	action: AnyAction
): CollectedState {
	// console.log(state.selectedButton +" "+ action.payload?.selectedButton + " " + (state.selectedButton < action.payload?.selectedButton))
	const selected = (state.selectedButton === undefined
		|| ( state.selectedButton === KehButton.NOT_SELECTED && action.payload?.selectedButton === undefined) )
			? KehButton.NOT_SELECTED
			: ((state.selectedButton < action.payload?.selectedButton) ? action.payload?.selectedButton : state.selectedButton);

	switch (action.type) {
		case CONTRACT_NEW:
			return {
				...state,
				status: CollectedSelection.FINISH_NOT_CHOSE,
				selectedButton: KehButton.NOT_SELECTED
			};
		case CONTRACT_UPDATE:
			return {
				...state,
				selectedButton: selected
			};
		case CONTRACT_WIZARD_NEXT_STEP:
			return {
				...state,
				selectedButton: selected
			};
		case FETCH_CONTENT_SUCCESS:
			return {
				...state,
				selectedButton: selected
			};
		case SELECTED_LATER:
			return {
				...state,
				status: CollectedSelection.FINISH_BY_MAIL_LATER
		};
		case SELECTED_NOW:
			return {
				...state,
				status: CollectedSelection.FINISH_BY_MAIL
			};
		case CONTRACT_WIZARD_PREVIOUS_FORM:
			return {
				...state,
				status: CollectedSelection.FINISH_NOT_CHOSE,
				selectedButton: KehButton.NOT_SELECTED
			};
		case CONTRACT_WIZARD_RESET_TO_STEP:
		case CONTRACT_WIZARD_RESET_TO_STEP_DONE:
		default:
			return {
			...state,
			selectedButton: KehButton.NOT_SELECTED
		};
	}
}
